import { configureStore } from "@reduxjs/toolkit";
import { fpSuspendMiddleware } from "./store/fpSuspendMiddleware";
import BoardInfoReducer from "./reducers/BoardInfoReducer";
import CommentListReducer from "./reducers/CommentListReducer";
import CommentNewListReducer from "./reducers/CommentNewListReducer";
import CommentRegReducer from "./reducers/CommentRegReducer";
import CommentRemoveReducer from "./reducers/CommentRemoveReducer";
import CommunityBoardDetailReducer from "./reducers/CommunityBoardDetailReducer";
import CommunityBoardGoodRegReducer from "./reducers/CommunityBoardGoodRegReducer";
import CommunityBoardListReducer from "./reducers/CommunityBoardListReducer";
import CommunityBoardRegReducer from "./reducers/CommunityBoardRegReducer";
import CommunityBoardRemoveReducer from "./reducers/CommunityBoardRemoveReducer";
import CommunityBoardWarningRegReducer from "./reducers/CommunityBoardWarningRegReducer";
import CommunityReplyListReducer from "./reducers/CommunityReplyListReducer";
import CommunityReplyRegReducer from "./reducers/CommunityReplyRegReducer";
import CommunityReplyRemoveReducer from "./reducers/CommunityReplyRemoveReducer";
import BoardJokeNextListReducer from "./reducers/BoardJokeNextListReducer";
import LoadingBarReducer from "./reducers/LoadingBarReducer";
import LoginBtnsReducer from "./reducers/LoginBtnsReducer";
import TopMainBtnsReducer from "./reducers/TopMainBtnsReducer";
import TopSearchReducer from "./reducers/TopSearchReducer";

const store = configureStore({
    reducer: {
        BoardInfoReducer,
        CommentListReducer,
        CommentNewListReducer,
        CommentRegReducer,
        CommentRemoveReducer,
        CommunityBoardDetailReducer,
        CommunityBoardGoodRegReducer,
        CommunityBoardListReducer,
        CommunityBoardRegReducer,
        CommunityBoardRemoveReducer,
        CommunityBoardWarningRegReducer,
        CommunityReplyListReducer,
        CommunityReplyRegReducer,
        CommunityReplyRemoveReducer,
        BoardJokeNextListReducer,
        LoadingBarReducer,
        LoginBtnsReducer,
        TopMainBtnsReducer,
        TopSearchReducer,
    },
    // 안드로이드 웹뷰만의 문제로, 동영상(flowplayer)이 플레이 상태일 때 API를 호출하면 잔여 스트리밍이 끝난 시점에 맞춰 API 통신이 완료되어 버린다..
    // 해당 문제 해결을 위해 추가된 항목으로 API 호출 직전에 동영상 플레이를 강제로 종료해주는 기능이 구현되어 있으니 참고 요망! (챗GPT의 도움을 받음 ^^;)
    middleware: (getDefault) =>
        getDefault().concat(fpSuspendMiddleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>
export default store;